<template>
    <v-layout row wrap>
      <v-flex xs12>
        <v-select
          :items="items"
          return-object
          item-text="nazev"
          v-model="item"
          label="Doména"
          :hide-details="hideDetails"
          :outline="outline"
          class="mx-2"
          :rules="rules"
          :disabled="disabled"
        ></v-select>
      </v-flex>
    </v-layout>
  </template>
  <script>
  export default {
    data: function () {
      return {
        items: [],
        item: null
      }
    },
    props: {
      hideDetails: Boolean,
      outline: Boolean,
      rules: Array,
      value: Number,
      all: Boolean,
      disabled: Boolean
    },
    watch: {
      value (v) {
        var $f = this.items.filter((x) => x.id == v);
        if ($f.length > 0)
          this.item = $f[0];
        else
          this.item = null;
      },
      item (v) {
        this.$emit("changed", v);
        this.$emit("input", v.id);
      }
    },
    mounted: function() {
      this.load();
    },
    methods: {
      load: function(v) {
        window.api.get("ciselniky/domena").then(function(_body) {
          this.items = _body;
          if (this.value != null) {
            var $f = this.items.filter((x) => x.id == this.value);
            if ($f.length > 0)
              this.item = $f[0];
            else
              this.item = null;
          }
          else {
            this.item = null;
          }
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      }
    },
    components: {
  
    }
  }
  </script>
  <style scoped>
  .v-select__selection-text {
    max-width: 100px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/Domena.vue